import { Navigate, useParams } from 'react-router-dom';

/** Legacy `/post/:slug` links now resolve under `/blog/:slug`. */
export default function PostSlugRedirect() {
  const { slug } = useParams<{ slug: string }>();
  return <Navigate to={slug ? `/blog/${slug}` : '/blog'} replace />;
}
